import React from 'react';
const DeleteSvg = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M2 3.33333H14M11 3.33333L10.797 2.70183C10.6003 2.08986 10.502 1.78388 10.3195 1.55765C10.1584 1.35788 9.95156 1.20325 9.71787 1.10794C9.45323 1 9.14221 1 8.52018 1H7.47982C6.85779 1 6.54677 1 6.28213 1.10794C6.04844 1.20325 5.84156 1.35788 5.68047 1.55765C5.49804 1.78388 5.39969 2.08986 5.20298 2.70183L5 3.33333M12.5 3.33333V11.2667C12.5 12.5735 12.5 13.2269 12.2548 13.726C12.039 14.165 11.6948 14.522 11.2715 14.7457C10.7902 15 10.1601 15 8.9 15H7.1C5.83988 15 5.20982 15 4.72852 14.7457C4.30516 14.522 3.96095 14.165 3.74524 13.726C3.5 13.2269 3.5 12.5735 3.5 11.2667V3.33333M9.5 6.44444V11.8889M6.5 6.44444V11.8889"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteSvg;
